<head>
  <!-- Font Awesome -->
  <link rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        crossorigin="anonymous"
        referrerpolicy="no-referrer" />
</head>

<div class="header">
  <header id="site-header">
    <mat-toolbar color="primary" class="mat-elevation-z2">

      <!-- Header Wrapper -->
      <div class="header-wrapper">

        <!-- Left Section: Logo + Mobile Toggle -->
        <div class="header-left">
          <a class="navbar-brand d-flex align-items-center" (click)="currentView=null" aria-label="Back to Home">
            <img src="/assets/img/logo-aqua-trade-pwsp-horizontal.svg"
                 alt="AquaTrade Produced Water Sharing Portal" class="site-logo" decoding="async">
            <span class="h1 logo-title sr-only">AquaTrade</span>
          </a>

          <!-- Mobile toggle button -->
          <button mat-icon-button class="navbar-toggler" aria-label="Toggle navigation" (click)="mobileMenuOpen = !mobileMenuOpen">
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <!-- Center Section: Desktop Navigation -->
        <div class="header-center">

          <ng-container *ngIf="loginService.userOptional?.isGlobalAdmin">

            <a class="nav-link"
               [class.active]="activeTab === 'AdminDashboard'"
               (click)="openView('AdminDashboard')">
              <i class="fa-solid fa-table" aria-label="Admin Dashboard"></i>
              <span>Admin Dashboard</span>
            </a>

            <!-- Client Management -->
            <a class="nav-link"
               [class.active]="activeTab === 'ClientManagement'"
               (click)=manageAquatradeClients()>
              <i class="fa-solid fa-building" aria-label="Client Management"></i>
              <span>Client Management</span>
            </a>

            <!-- User Management -->
            <a class="nav-link"
               [class.active]="activeTab === 'UserManagement'"
               (click)=manageAquatradeUsers()>
              <i class="fa-solid fa-user" aria-label="User Management"></i>
              <span>User Management</span>
            </a>

            <div class="divider"></div>
          </ng-container>
          <ng-container *ngIf="isAquashareEnabled$ | async">
            <a class="nav-link"
               [class.active]="activeTab === 'waterSharing'"
               (click)="openView('waterSharing', true)">
              <i class="fa-solid fa-handshake" aria-label="Water Sharing"></i>
              <span>Water Sharing</span>
            </a>

            <a class="nav-link"
               [class.active]="activeTab === 'sharingDashboard'"
               (click)="openView('sharingDashboard')">
              <i class="fa-solid fa-table" aria-label="Sharing Dashboard"></i>
              <span>Sharing Dashboard</span>
            </a>

            <a class="nav-link"
               [class.active]="activeTab === 'shareStats'"
               (click)="openView('shareStats', true)">
              <i class="fa-solid fa-chart-line" aria-label="Trade Statistics"></i>
              <span>Share Statistics</span>
            </a>

            <div class="divider"></div>
          </ng-container>         

          <ng-container *ngIf="isAquatradeEnabled$ | async">
            <a class="nav-link"
               [class.active]="activeTab === 'waterTrading'"
               (click)="openView('waterTrading', true)">
              <i class="fa-solid fa-dollar-sign" aria-label="Water Trading"></i>
              <span>Water Trading</span>
            </a>

            <a class="nav-link"
               [class.active]="activeTab === 'tradingDashboard'"
               (click)="openView('tradingDashboard')">
              <i class="fa-solid fa-table" aria-label="Trading Dashboard"></i>
              <span>Trading Dashboard</span>
            </a>

            <a class="nav-link"
               [class.active]="activeTab === 'tradeStats'"
               (click)="openView('tradeStats', true)">
              <i class="fa-solid fa-chart-line" aria-label="Trade Statistics"></i>
              <span>Trade Statistics</span>
            </a>
          </ng-container>
          
        </div>

        <!-- Right Section: Back Button -->
        <div class="header-back">
          <a class="back-button nav-link" (click)="goBack()">
            <img src="/assets/img/icon.png"
                 alt="Well Chron"
                 class="logo-icon">
            <!--<span class="back-text">Well Chron</span>-->
          </a>
        </div>

      </div>
    </mat-toolbar>
  </header>

  <!-- Mobile Drawer Menu -->
  <mat-nav-list *ngIf="mobileMenuOpen" class="mobile-menu">
    <a mat-list-item (click)="openView('waterSharing')">
      <mat-icon>handshake</mat-icon>
      <span>Water Sharing</span>
    </a>

    <a mat-list-item (click)="openView('sharingDashboard')">
      <mat-icon>table_chart</mat-icon>
      <span>Sharing Dashboard</span>
    </a>

    <a mat-list-item (click)="openView('waterTrading')">
      <mat-icon>attach_money</mat-icon>
      <span>Water Trading</span>
    </a>

    <a mat-list-item (click)="openView('tradingDashboard')">
      <mat-icon>table_rows</mat-icon>
      <span>Trading Dashboard</span>
    </a>

    <a mat-list-item (click)="openView('tradeStats')">
      <mat-icon>show_chart</mat-icon>
      <span>Trade Statistics</span>
    </a>
  </mat-nav-list>
</div>

<div class="dsgnr-wrap">

  <main class="dsgnr-body" id="dsgnrContent" role="main">

    <!-- Home view: shows only when no currentView is selected -->
    <ng-container *ngIf="!currentView">
      <div style="height:44px" aria-hidden="true" class="wp-block-spacer"></div>

      <section class="section-layout-block section-with-card">
        <div class="container single-content-layout-layout-block mb-5">
          <div class="row justify-content-center">
            <div class="column-block col-12 col-md-10 col-lg-8 card-like card-like-lg text-center inner-wrap">

              <h1 class="wp-block-heading color-black">
                Welcome to AquaTrade, the free and open produced water exchange portal
              </h1>
              <p class="p-lg">
                We offer two distinct solutions to help you accelerate your produced water exchange goals.
                Choose one of our portals to begin:
              </p>

              <div class="container two-column-layout-layout-block">
                <div class="row align-items-center">

                  <!-- Sharing Portal -->
                  <div *ngIf="loginService.userOptional?.enableAquashare" class="column-block col-12 col-lg-6 mb-4 mb-lg-0 text-center">
                    <figure class="wp-block-image aligncenter size-full">
                      <img src="/assets/img/share-portal.svg"
                           alt="Water Sharing Portal"
                           class="wp-image-1635 img-fluid mb-3">
                    </figure>

                    <h2 class="wp-block-heading color-black">Water Sharing Portal</h2>
                    <p class="p-sm">
                      Offer produced water freely to the community, or request it.
                      Our Sharing portal will help you intensify produced water recycling
                      without added financial requirements.
                    </p>

                    <button class="btn-primary"
                            (click)="openView('waterSharing')"
                            [disabled]="!(isAquashareEnabled$ | async)">
                      Go to <strong>Sharing</strong> Portal
                    </button>
                  </div>

                  <!-- Trading Portal -->
                  <div *ngIf="loginService.userOptional?.enableAquatrade" class="column-block col-12 col-lg-6 text-center">
                    <figure class="wp-block-image aligncenter size-full">
                      <img src="/assets/img/trade-portal.svg"
                           alt="Water Trading Portal"
                           class="wp-image-1636 img-fluid mb-3">
                    </figure>

                    <h2 class="wp-block-heading color-black">Water Trading Portal</h2>
                    <p class="p-sm">
                      Our Trading portal will allow you to bid to buy or sell produced water.
                      If you need to make water move, our Trading portal will give the tools
                      to add incentives to your offers*.
                    </p>

                    <button class="btn-primary"
                            (click)="openView('waterTrading')"
                            [disabled]="!(isAquatradeEnabled$ | async)">
                      Go to <strong>Trading</strong> Portal
                    </button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </ng-container>

    <!-- Dynamic component views -->
    <ws-menu *ngIf="currentView === 'waterSharing'"
             [currentForm]="currentFormSharing"
             [context]="'Share'"
             (formChange)="onFormChange($event)">
    </ws-menu>

    <ws-menu *ngIf="currentView === 'waterTrading'"
             [currentForm]="currentFormTrading"
             [context]="'Trade'"
             (formChange)="onFormChange($event)">
    </ws-menu>

    <ws-dashboard *ngIf="currentView === 'dashboard'" [viewType]="dashboardType"></ws-dashboard>
    <ws-trade-stats *ngIf="currentView === 'tradeStats'"
                    [type]="'trade'"
                    [userClientId]="workingClientId!">
    </ws-trade-stats>

    <ws-trade-stats *ngIf="currentView === 'shareStats'"
                    [type]="'share'"
                    [userClientId]="workingClientId!">
    </ws-trade-stats>

  </main>

</div>
